import { Grid, useEventCallback } from '@mui/material';
import { Form, Formik } from 'formik';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ResponseAnprData, ResponseAnprSaveData } from 'shell/models/person';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { __PERSON_API_URL__, __PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import {
  checkPersonRegistrationWidowhood,
  transformerRegistrationWidowhood,
} from 'mutation/utils/transformer-registration-widowhood';
import ExitModal from 'mutation/components/shared/exit-modal';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { transformerRequestRegistrationWidowhoodData } from 'mutation/utils/transformer-request-registration-widowhood';
import { toast } from 'react-toastify';
import { validationSchema } from 'mutation/constants/registration-widowhood-validation';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Buttons from 'mutation/components/registration-widowhood/buttons';
import FormRegistrationWidowhood from 'mutation/components/registration-widowhood/form';
import { RegistrationWidowhoodFormVM } from 'mutation/view-models/registration-widowhood';
import { SaveDataAnpr } from 'shell/view-models/save-data-anpr';
import { transformResponseSaveDataAnpr } from 'shell/utils/save-data-anpr-response-transformer';
import SearchMessages, { MessageType } from 'shell/components/shared/search-messages';
import { ItemVM } from 'shell/view-models/item';
import { RegistrationWidowhoodCrumbs } from 'mutation/constants/registration-widowhood-crumbs';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { PersonSearchStorageVM } from 'shell/view-models/search-anpr';
import ErrorModal from 'mutation/components/shared/error-modal';
import PmiTitle from 'shell/components/shared/title';
import { CivilStatusID } from 'shell/constants/civil-status';
import { transformDeathActAnpr05 } from 'shell/utils/consult-person/response-transformer/data-deletion/death-data-act-anpr05';
import { genericTransformer } from 'shell/utils/generic-transformer';

const RegistrationMarriagePage = (): React.ReactElement => {
  //Modal state
  const [open, setOpen] = useState<boolean>(false);

  const [queryParams] = useSearchParams();
  // query params
  const nationalSearch = JSON.parse(queryParams.get('ricercaNazionale') || 'false');
  const fiscalCode = queryParams.get('codiceFiscale') || '';
  const idSchedaSoggettoANPR = queryParams.get('idSchedaSoggettoANPR') || '';

  const filterTable = useFilterTable<PersonSearchStorageVM>();

  const [anpr, getAnpr] = useHttpFetch<HttpResponse<ResponseAnprData>, RegistrationWidowhoodFormVM>(
    `${__PERSON_NEW_API_URL__}/persona`,
    {
      onBootstrap: false,
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {
          criteriRicerca: {
            codiceFiscale: fiscalCode || undefined,
            idSchedaSoggettoANPR: idSchedaSoggettoANPR || filterTable?.values?.subject?.anpr,
          },
          datiRichiesta: {
            ricercaNazionale: nationalSearch ? '1' : '0',
            dataRiferimentoRichiesta:
              filterTable?.values?.filters?.subjectData?.referenceDate?.toFormat('yyyy-MM-dd') ||
              undefined,
            comuneResidenza:
              filterTable.values?.filters?.commonSearch?.provinceOfResidence ||
              filterTable.values?.filters?.commonSearch?.municipalityOfResidence?.id ||
              filterTable.values?.filters?.subjectData?.provinceOfResidence ||
              filterTable.values?.filters?.subjectData?.municipalityOfResidence?.id
                ? {
                    siglaProvinciaIstat:
                      filterTable.values?.filters?.commonSearch?.municipalityOfResidence
                        ?.province ||
                      filterTable.values?.filters?.subjectData?.municipalityOfResidence?.province ||
                      undefined,
                    codiceIstat:
                      filterTable.values?.filters?.commonSearch?.municipalityOfResidence?.id ||
                      filterTable.values?.filters?.subjectData?.municipalityOfResidence?.id ||
                      undefined,
                    nomeComune:
                      filterTable.values?.filters?.commonSearch?.municipalityOfResidence
                        ?.description ||
                      filterTable.values?.filters?.subjectData?.municipalityOfResidence
                        ?.description ||
                      undefined,
                  }
                : undefined,
          },
        },
      },
      transformer: transformerRegistrationWidowhood,
    }
  );

  const [anprConiuge, getAnprConiuge] = useHttpFetch<
    HttpResponse<ResponseAnprData>,
    HttpResponse<ResponseAnprData>
  >(`${__PERSON_NEW_API_URL__}/persona`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
    },
    transformer: genericTransformer,
  });

  useEffect(() => {
    (
      getAnpr() as ResponsePromise<HttpResponse<ResponseAnprData>, RegistrationWidowhoodFormVM>
    ).then((response) => {
      const anprConiugeResponse = response as RegistrationWidowhoodFormVM;

      //let idSchedaSoggettoANPRConiuge = anprConiugeResponse.marriage?.generality?.anprIdentifier;
      let codiceFiscaleConiuge = anprConiugeResponse.marriage?.generality?.fiscalCode;

      if (
        anprConiugeResponse.civilStatus?.status ===
        CivilStatusID.scioglimentoUnitoCivilmenteASeguitoDelDecesso
      ) {
        //idSchedaSoggettoANPRConiuge = anprConiugeResponse.civilUnion?.generality?.anprIdentifier;
        codiceFiscaleConiuge = anprConiugeResponse.civilUnion?.person?.fiscalCode;
      }

      if (codiceFiscaleConiuge) {
        (
          getAnprConiuge({
            data: {
              criteriRicerca: {
                codiceFiscale: codiceFiscaleConiuge,
                //idSchedaSoggettoANPR: idSchedaSoggettoANPRConiuge,
              },
              datiRichiesta: {
                ricercaNazionale: '1',
              },
            },
          }) as ResponsePromise<HttpResponse<ResponseAnprData>, HttpResponse<ResponseAnprData>>
        ).then((res) => {
          const anprConiugeResponseList = res as HttpResponse<ResponseAnprData>;
          if (
            anprConiugeResponseList.payload.risposta3002OK?.listaSoggetti?.datiSoggetto?.length > 1
          )
            setOpenErrorAnpr(true);
        });
      }
    });
  }, []);

  const [responseData, registerWidowhood] = useHttpFetch<
    HttpResponse<ResponseAnprSaveData>,
    SaveDataAnpr
  >(`${__PERSON_API_URL__}/persona/registrazione-vedovanza`, {
    onBootstrap: false,
    options: {
      method: 'POST',
    },
    transformer: transformResponseSaveDataAnpr,
  });

  const castedSavedData = responseData.data as SaveDataAnpr;

  // visibility
  const [visibility, setVisibility] = useState<{ error?: boolean; warning?: boolean }>({
    error: undefined,
    warning: undefined,
  });

  // on change visibility
  const onVisibility = useCallback(
    (openV, type) => {
      const visibilityMessage = type === 'error' && !openV ? false : openV;

      setVisibility((oldState) => ({ ...oldState, [type]: visibilityMessage }));
    },
    [setVisibility]
  );

  const navigate = useNavigate();

  const handleSubmit = useEventCallback((values: RegistrationWidowhoodFormVM) => {
    const data = transformerRequestRegistrationWidowhoodData(values);

    (
      registerWidowhood({ data }) as ResponsePromise<HttpResponse<ResponseAnprData>, SaveDataAnpr>
    ).then((response) => {
      const castedResponse = response as SaveDataAnpr;
      if (castedResponse?.errors?.length) {
        return;
      }
      toast.success('Operazione eseguita con successo');
      navigate('/mutazioni/persona/vedovanza');
    });
  });

  const handleExit = useEventCallback(() => {
    navigate('/mutazioni/persona/vedovanza');
  });

  const handleOpenModal = useEventCallback(() => {
    setOpen(true);
  });

  const isLoading = !anpr.data || anpr.isLoading || anprConiuge.isLoading;

  //Errors
  const errorMessage = useMemo(() => {
    const errorToVisualize: { visibility?: boolean; title?: string; messages?: Array<ItemVM> } = {
      visibility: false,
      title: '',
    };

    if (castedSavedData?.errors?.length && visibility.error === undefined) {
      errorToVisualize.title =
        castedSavedData?.errors?.length > 1
          ? `Ci sono ${castedSavedData?.errors?.length} errori`
          : `C'è 1 errore`;
      errorToVisualize.messages = castedSavedData?.errors;
      errorToVisualize.visibility = true;
      return errorToVisualize;
    }

    errorToVisualize.visibility = visibility.error;

    return errorToVisualize;
  }, [visibility.error, castedSavedData]);

  const [openError, setOpenError] = useState<boolean>(false);

  const [openErrorAnpr, setOpenErrorAnpr] = useState<boolean>(false);

  useEffect(() => {
    const data = anpr.data as RegistrationWidowhoodFormVM;

    const canBeMutated = checkPersonRegistrationWidowhood(data?.civilStatus?.oldStatus);

    if (!canBeMutated) {
      // persona già coniugata
      setOpenError(true);
    }
  }, [anpr.data]);

  const onCloseErrorModal = useEventCallback((value: boolean) => {
    setOpenError(value);
    navigate('/mutazioni/persona/vedovanza');
  });

  const onCloseErrorModalAnpr = useEventCallback((value: boolean) => {
    setOpenErrorAnpr(value);
  });

  const initialValues = anpr.data as RegistrationWidowhoodFormVM;
  const partnerDeathAct = (anprConiuge.data as HttpResponse<ResponseAnprData>)?.payload
    ?.risposta3002OK?.listaSoggetti?.datiSoggetto[0]
    ? transformDeathActAnpr05(
        (anprConiuge.data as HttpResponse<ResponseAnprData>)?.payload?.risposta3002OK?.listaSoggetti
          ?.datiSoggetto[0]
      )
    : undefined;

  return !isLoading ? (
    <Fragment>
      <ErrorModal
        open={openError}
        onClose={onCloseErrorModal}
        message="Stato civile del soggetto incongruente con la registrazione vedovanza"
      />
      <ErrorModal
        open={openErrorAnpr}
        onClose={onCloseErrorModalAnpr}
        message="Sono stati trovati più soggetti con lo stesso codice fiscale, inserire manualmente i dati del coniuge"
      />
      <Breadcrumbs items={RegistrationWidowhoodCrumbs} />
      <PmiTitle title="Registrazione Vedovanza" />
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          ...initialValues,
          widowhood: partnerDeathAct || initialValues.widowhood,
        }}
        onSubmit={handleSubmit}
      >
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} md={2}>
              <Buttons handleOpenModal={handleOpenModal} />
            </Grid>
            <Grid item xs={12} md={10}>
              <Grid item container xs={12} spacing={1}>
                <Grid item xs={12}>
                  <SearchMessages
                    type={MessageType.Error}
                    title={errorMessage.title || ''}
                    messages={errorMessage.messages || []}
                    visibility={errorMessage.visibility || false}
                    onChangeVisibility={onVisibility}
                  />
                  <SearchMessages
                    type={MessageType.Warning}
                    title={
                      castedSavedData?.warnings?.length === 1
                        ? `C'è 1 warning`
                        : `Ci sono ${castedSavedData?.warnings?.length} warning`
                    }
                    messages={castedSavedData?.warnings || []}
                    visibility={
                      visibility.warning !== undefined
                        ? visibility.warning
                        : (castedSavedData?.warnings || [])?.length > 0
                    }
                    onChangeVisibility={onVisibility}
                  />
                  <FormRegistrationWidowhood />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <ExitModal open={open} onClose={() => setOpen(false)} onConfirm={handleExit} />
        </Form>
      </Formik>
    </Fragment>
  ) : (
    <></>
  );
};

RegistrationMarriagePage.displayName = 'Registration wdowhood page component';

export default RegistrationMarriagePage;
